export const API_BASE_URL =
  'https://front-br-challenges.web.app/api/v2/green-thumb/';
